export type AddressFields = {
  address_line_one?: unknown;
  address_line_two?: unknown;
  city?: unknown;
  state?: unknown;
  zip?: unknown;
  zip_code?: unknown;
  country?: unknown;
};

export function formatAddress(address?: AddressFields | null) {
  if (!address) {
    return undefined;
  }

  return [
    address.address_line_one,
    address.address_line_two,
    address.city,
    address.state,
    address.zip || address.zip_code,
    address.country,
  ]
    .filter((value): value is string => typeof value === 'string' && !!value)
    .join(', ');
}
